module.exports = __webpack_public_path__ + "static/media/Armario.dc61d0b0.jpg";